var Activity = function () {

    "use strict";
    var self = this;

    this.id;
    this.name;
    this.people;
    this.price;
    this.singleUnit;

};

Activity.prototype.setId = function (id) {
    this.id = id;
};

Activity.prototype.setName = function (name) {
    this.name = name;
};

Activity.prototype.setPeople = function (people) {
    this.people = people;
};

Activity.prototype.setPrice = function (price) {
    this.price = price;
};

Activity.prototype.setSingleUnit = function (singleUnit) {
    this.singleUnit = singleUnit;
};

export default Activity;
